<template>
  <v-container>
      <v-card :disabled="loading" :loading="loading">
        <v-toolbar flat color="secondary" dark>
            Reporting
            <v-spacer></v-spacer>
            <v-toolbar-items class="hidden-sm-and-down" v-if="dataSets.length">
                <download
                    label="Download data"
                    url="stats/export"
                    filename="stats.csv"
                    :data="{data,xAxis,groupBy,filter,range,}"
                ></download>
            </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
            <v-row>
                <v-col>
                    <v-select :items="dataItems" label="Data" v-model="data"/>
                </v-col>
                <v-col>
                    <v-select :items="groupByItems" label="Group By" v-model="groupBy"/>
                </v-col>
                <v-col>
                    <v-menu
                        ref="rangeMenu"
                        v-model="rangeMenu"
                        :close-on-content-click="false"
                        :return-value.sync="date"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="range"
                                label="Date Range"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                        </template>
                            <v-date-picker
                                v-model="range"
                                no-title
                                scrollable
                                range
                            >
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="rangeMenu = false">Cancel</v-btn>
                                <v-btn text color="primary" @click="$refs.rangeMenu.save(date)">OK</v-btn>
                            </v-date-picker>
                    </v-menu>
                </v-col>
            </v-row>
            <v-row justify="center">
                <v-col class="text-center">
                    <v-btn color=primary @click="generateReport">Generate</v-btn>
                </v-col>
            </v-row>
        </v-card-text>
      </v-card>
      <v-card>
        
        <v-data-table
            :headers="headers"
            :items="dataSets"
            :loading="loading"
            :options.sync="options"
            v-if="dataSets.length && data == 'sumSale'"
        >
        </v-data-table>
        <v-data-table
            :headers="headers"
            :items="dataSets"
            :loading="loading"
            :options.sync="options"
            v-if="dataSets.length && data != 'sumSale'"
        >
            <template #[`item.currency`]>
                <div>
                    <div>CHF</div>
                    <div>EUR</div>
                    <div>GBP</div>
                </div>
            </template>
            <template v-for="h in customHeaders" #[`item.${h.value}`]="{item}">
                <div :key="h.value">
                    <div>{{ item[h.text][1] | currency('') }}</div>
                    <div>{{ item[h.text][2] | currency('') }}</div>
                    <div>{{ item[h.text][3] | currency('') }}</div>
                </div>
            </template>
            <template #[`item.total`]="{item}">
                <div>
                    <div>{{ item.total[1] | currency('') }}</div>
                    <div>{{ item.total[2] | currency('') }}</div>
                    <div>{{ item.total[3] | currency('') }}</div>
                </div>
            </template>
        </v-data-table>
      </v-card>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import Download from '@components/Download.vue';
export default {
  components: { Download },
    data:()=>({
        options: { itemsPerPage: 15, sortBy: ["id"], sortDesc: [true] },
        headers: [
            { text: "Brand", value: "key", align: "left" }
        ],
        customHeaders: [],
        dataSets:[],
        dataItems:[
            {value:'sumSale',text:'# Sales'},
            {value:'pnl',text:'PnL'},
            {value:'turnover',text:'Turnover (product only HT)'},
            {value:'fittingFees',text:'Fitting Fees'},
            {value:'shippingFees',text:'Shipping Fees'}
        ],
        groupByItems:[
            {value:'fitter',text:'Fitter'},
            {value:'shop',text:'Shop'},
            {value:'location',text:'Location'},
            {value:'brand',text:'Brands'},
        ],
        data:null,
        xAxis:null,
        groupBy:null,
        filter:null,
        range:null,
        date:null,
        rangeMenu:null,
        loading:false
    }),
    watch: {
        data () {
            this.dataSets = []
        }
    },
    methods:{
        ...mapActions("stats",["generate"]),
        generateReport(){
            this.dataSets=[];
            this.loading=true
            this.generate({
                data:this.data,
                xAxis:this.xAxis,
                groupBy:this.groupBy,
                filter:this.filter,
                range:this.range,
            })
            .then((data)=>{
                let keys = Object.keys(data[0])
                keys = keys.filter(key => key!='key' && key!='total');
                this.customHeaders = keys.map(key => {return {text: key, value: key, align: 'right'}});
                this.headers = [
                    { text: "Brand", value: "key", align: "left" }
                ]
                if(this.data != 'sumSale') {
                    this.headers.push({ text: "Currency", value: "currency", align: "left" })
                }
                this.headers = this.headers.concat([
                    ...this.customHeaders,
                    { text: "Total", value: "total", align: "right" }
                ])
                    
                this.dataSets = data;
            })
            .finally(() => {
                this.loading=false
            })
        }
    }
}
</script>

<style>

</style>